import * as DropdownMenu from '@radix-ui/react-dropdown-menu';
import { Download, RotateCcw } from 'lucide-react';
import React from 'react';
import { Button } from '@/components/ui/button';

interface MenuItem {
  label: string;
  onClick?: () => void;
  icon?: React.ReactNode;
}

interface DropDownMenuProps {
  menuName: string;
  isLoading: boolean;
  items: MenuItem[];
}

export const DropDownMenu = ({
  menuName,
  isLoading,
  items,
}: DropDownMenuProps) => {
  return (
    <DropdownMenu.Root>
      <DropdownMenu.Trigger asChild>
        <Button
          type="button"
          variant="outline"
          size="sm"
          disabled={isLoading}
          className="gap-2"
        >
          {isLoading ? (
            <RotateCcw className="h-4 w-4 shrink-0 animate-spin" />
          ) : (
            <Download className="h-4 w-4 shrink-0" />
          )}
          {menuName}
        </Button>
      </DropdownMenu.Trigger>

      <DropdownMenu.Content
        side="top"
        align="start"
        sideOffset={5}
        style={{
          background: 'white',
          border: '1px solid #ccc',
          padding: 10,
          borderRadius: 6,
        }}
      >
        {items.map((item, index) => (
          <DropdownMenu.Item
            key={index}
            onSelect={item.onClick}
            style={{
              padding: '6px 12px',
              cursor: 'pointer',
              display: 'flex',
              alignItems: 'center',
              gap: '8px',
            }}
          >
            {item.icon}
            {item.label}
          </DropdownMenu.Item>
        ))}
      </DropdownMenu.Content>
    </DropdownMenu.Root>
  );
};
